// lib/ensureAuthReady.ts - 温柔门闸（不丢错、不 abort）
import { supabase } from './supabaseClient';

let inflight: Promise<void> | null = null;

export async function ensureAuthReady(budgetMs = 1000) {
  if (!inflight) {
    inflight = (async () => {
      console.log('🔐 ensureAuthReady: 開始等待 Auth 就緒');
      // 1) 启动刷新/读取 session（不会抛错）
      await supabase.auth.getSession();
      // 2) 微暂停，让 header/状态收敛
      await new Promise(r => setTimeout(r, 120));
      console.log('🔐 ensureAuthReady: Auth 已就緒');
    })().finally(() => { 
      inflight = null; 
    });
  }
  
  // 3) 设一个「等最多 budgetMs」的 Race，但**不要 throw**
  await Promise.race([
    inflight,
    new Promise(r => setTimeout(r, budgetMs)),
  ]);
  
  return true; // 不管结果如何，一律放行
}
